module.exports = "/_next/static/images/UseAI@2x-1b90a14a1883901e9ddf02c22f83f71e.webp";